import { css } from '@emotion/react';
export const submitButtonStyles = css`
  margin-left: auto;
  padding-right: ${"var(--ds-space-100, 8px)"};
  padding-left: ${"var(--ds-space-100, 8px)"};
  margin-right: ${"var(--ds-space-075, 6px)"};
`;